import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectDocuments = createSelector(
  [
    (store: RootState) => store.userShow.documents,
    (store: RootState) => store.userShow.documentSearchText,
  ],
  (documents, searchText) =>
    (documents || []).filter(({ title }) =>
      title?.toLowerCase().includes((searchText || "").toLowerCase() || "")
    )
);
